import { cls } from "@wss/cls";
import React, { useState, useEffect } from "react";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import { fetchMostRecentMessage, fetchNotificationBarData } from "./requests";
interface NotificationBarProps {
  mounted?: boolean;
  user: User;
}
function NotificationBar({
  user
}: NotificationBarProps) {
  const [mostRecentOrder, setMostRecentOrder] = useState({
    orderNumber: 0,
    dateOrdered: "",
    orderStatus: "",
    dateShipped: "",
    orderItemCount: 0
  });
  const [statusBarFlags, setStatusBarFlags] = useState({
    orderNumberEncrypted: "",
    showStatusBar: false,
    showMostRecentOrder: false,
    showAbandonCartMessage: false
  });
  const [mostRecentMessage, setMostRecentMessage] = useState("");
  const {
    showStatusBar,
    showMostRecentOrder,
    showAbandonCartMessage
  } = statusBarFlags;
  useEffect(() => {
    const setNotificationBarData = async () => {
      const result = await fetchNotificationBarData();
      if (result.isError) return;
      setMostRecentOrder(result.value.mostRecentOrder);
      setStatusBarFlags(result.value.statusBarFlags);
    };
    setNotificationBarData();
  }, []);
  useEffect(() => {
    const updateMessage = async () => {
      if (user.registered && showStatusBar && showMostRecentOrder) {
        const result = await fetchMostRecentMessage();
        if (result.isError) return;
        setMostRecentMessage(result.value.emailSubject);
      }
    };
    updateMessage();
  }, [showStatusBar, showMostRecentOrder, user]);
  return <div className={cls("transition-[max-height] duration-300 ease-in-out container hidden lt:block", user.registered && showStatusBar ? "max-h-22 mb-6" : "max-h-0 mb-0")} data-sentry-component="NotificationBar" data-sentry-source-file="index.tsx">
      {user.registered && showStatusBar && <div data-testid="homepage-order-status">
          <div className={cls("bg-gray-900 flex", showAbandonCartMessage ? "justify-center" : "justify-between")}>
            <div className="text-2xl min-w-35 py-8 px-7 relative capitalize flex items-center justify-center after:content-[''] after:absolute after:right-0 after:w-px after:bg-gray-500 after:h-1/2">
              <a className="text-white leading-none" href="/myaccount">{`Hi, ${user.firstName}`}</a>
            </div>
            {showMostRecentOrder && mostRecentOrder && <a href={`/myaccount/orders/details/${mostRecentOrder.orderNumber}`} className="flex items-center mr-auto pl-5 text-white">
                <ul className="list-none m-0 p-0 flex">
                  <li className="pl-4 pr-6 pb-1 leading-tight">
                    <span className="text-white opacity-50 block text-xs">
                      Recent Order
                    </span>
                    {`#${mostRecentOrder.orderNumber}`}
                  </li>
                  <li className="pr-6 pb-1 leading-tight">
                    <span className="text-white opacity-50 block text-xs">
                      On Order
                    </span>
                    {mostRecentOrder.orderItemCount}
                    {` Item${Number(mostRecentOrder.orderItemCount) > 1 ? "s" : ""}`}
                  </li>
                  <li className="pr-6 pb-1 leading-tight">
                    <span className="text-white opacity-50 block text-xs">
                      Order Status
                    </span>
                    {mostRecentOrder.orderStatus}
                  </li>
                </ul>
              </a>}
            <div className="items-center flex">
              {Object.keys(user.autoReorders).length > 0 && <p id="next-auto-reorder" className="text-white mb-0 m-0 px-4 max-w-3xs">
                  <span className="text-white opacity-50 block text-xs leading-normal mb-0">
                    Next Auto Reorder Shipment
                  </span>
                  <span className="overflow-ellipsis break-all line-clamp-1">
                    {user.autoReorders.desiredOrderDate}
                  </span>
                  <a className="mb-0 block text-xs text-green-500" href={`/myaccount:autoreorder/detail/?r=${user.autoReorders.id}`}>
                    View Items
                  </a>
                </p>}
              {!!mostRecentMessage.trim() && <div id="recent-message" className="text-white mb-0 px-4 lt:max-w-[8rem] xl:max-w-xs">
                  <span className="text-white opacity-50 block text-xs leading-normal mb-0">
                    Recent Message
                  </span>
                  <span id="recent-message-subject" className="overflow-ellipsis line-clamp-1 break-all">
                    {mostRecentMessage}
                  </span>
                  <a className="mb-0 text-green-500 block text-xs" href="/myaccount/email-communications/">
                    View Message
                  </a>
                </div>}
              {showAbandonCartMessage && <p id="abandon-cart-prompt" className="text-2xl leading-5 px-4 py-5 text-white mb-0">
                  Still deciding? Review your Cart
                  <a className="bg-green-500 text-white rounded text-xs leading-3 px-5 py-2 ml-5 relative -top-1" href="/viewcart.cfm">
                    View Cart
                  </a>
                </p>}
            </div>
          </div>
        </div>}
    </div>;
}
export default withUserAndChat(NotificationBar);